import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkScrapRequestDto, BulkScrapStatusLogDto } from '../../services/bulk-scrap-request.service';
import {
  BulkScrapSourceBadgeComponent,
  BulkScrapStatusBadgeComponent,
} from './bulk-scrap-badges.component';
import { BulkScrapStatusEditorComponent } from './bulk-scrap-status-editor.component';

export interface PhotoOpenEvent {
  url: string;
  trigger: HTMLElement;
}

/** Slide-over details panel (AGENTS.md: sliding panels instead of pop-ups). */
@Component({
  selector: 'app-bulk-scrap-request-details',
  standalone: true,
  imports: [
    CommonModule,
    BulkScrapStatusBadgeComponent,
    BulkScrapSourceBadgeComponent,
    BulkScrapStatusEditorComponent,
  ],
  templateUrl: './bulk-scrap-request-details.component.html',
})
export class BulkScrapRequestDetailsComponent implements AfterViewInit {
  @Input({ required: true }) request!: BulkScrapRequestDto;
  @Input() canManageStatus = false;
  @Output() closed = new EventEmitter<void>();
  @Output() statusSaved = new EventEmitter<BulkScrapRequestDto>();
  @Output() photoOpened = new EventEmitter<PhotoOpenEvent>();

  @ViewChild('closeButton') closeButton?: ElementRef<HTMLButtonElement>;

  isEditingStatus = false;

  ngAfterViewInit(): void {
    // Move focus into the panel so keyboard and screen-reader users land in it.
    setTimeout(() => this.closeButton?.nativeElement.focus());
  }

  /** Newest first. */
  get history(): BulkScrapStatusLogDto[] {
    return [...(this.request.statusHistory ?? [])].sort(
      (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    );
  }

  onStatusSaved(updated: BulkScrapRequestDto): void {
    this.isEditingStatus = false;
    this.statusSaved.emit(updated);
  }

  openPhoto(url: string, event: Event): void {
    this.photoOpened.emit({ url, trigger: event.currentTarget as HTMLElement });
  }
}
